import DefaultLayout from '@components/_templates/DefaultLayout';
import withAuth from '@components/hocs/withAuth';
import { projectSaleQuotationPath } from '@constants/routes/routes';
import { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';

/**
 *  @todo
 *  9월 이후 코드 제거
 *  필요 없는 페이지이나 push로 이미 날라간 url 때문에 사용자의 직접접근 가능성이있어 리다이렉트 로직 추가해놓음
 */
const Sale: NextPage = () => {
  const router = useRouter();

  const { rfq_number_id, sale_quotation_id } = router.query as { rfq_number_id?: number; sale_quotation_id?: number };

  if (rfq_number_id) {
    const PROJECT_SALE_QUOTATION = projectSaleQuotationPath.query({ rfq_number_id, sale_quotation_id });
    router.replace(PROJECT_SALE_QUOTATION);
  }

  return <DefaultLayout>{}</DefaultLayout>;
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['project', 'common', 'component'])),
  },
});

export default withAuth(Sale);
